import { t as e } from "./cx-BjmrJCen.js";
/* empty css                              */
import { jsx as t } from "react/jsx-runtime";
//#region src/components/auth-layout/auth-layout.css.ts
var n = "hjmop40", r = "hjmop41", i = "hjmop42", a = "hjmop43", o = "hjmop44", s = "hjmop45", c = "hjmop46", l = "hjmop47";
//#endregion
//#region src/components/auth-layout/auth-layout.tsx
function u({ children: r, className: i, ...a }) {
	return /* @__PURE__ */ t("main", {
		...a,
		className: e(n, i),
		children: r
	});
}
function d({ children: n, className: i, ...a }) {
	return /* @__PURE__ */ t("section", {
		...a,
		className: e(r, i),
		children: n
	});
}
function f({ children: n, className: r, ...a }) {
	return /* @__PURE__ */ t("div", {
		...a,
		className: e(i, r),
		children: n
	});
}
function p({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("div", {
		...i,
		className: e(a, r),
		children: n
	});
}
function m({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("div", {
		...i,
		className: e(o, r),
		children: n
	});
}
function h({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("strong", {
		...i,
		className: e(s, r),
		children: n
	});
}
function g({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("p", {
		...i,
		className: e(c, r),
		children: n
	});
}
function _({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("div", {
		...i,
		className: e(l, r),
		children: n
	});
}
//#endregion
export { d as AuthCard, m as AuthHighlight, h as AuthHighlightTitle, p as AuthHighlights, _ as AuthPanel, u as AuthShell, g as AuthTag, f as AuthVisual };

//# sourceMappingURL=auth-layout.js.map